import type { PrometheusMetric, Counter, Histogram } from './prometheus.interfaces';

export function render({ name, labels, value }: PrometheusMetric): string {
    const formattedLabels = Object.entries(labels)
        .map(([key, val]) => `${key}="${val}"`)
        .join(', ');
    const body = `${name}{${formattedLabels}} ${value ?? 1}`;
    return body;
}

export function renderMany(metrics: PrometheusMetric[]): string {
    return metrics.map(render).concat('').join('\n');
}

export function buildCounter(
    name: string,
    action: (metric: PrometheusMetric) => void
): Counter {
    return {
        inc: (labels: Record<string, string>, value = 1): void =>
            action({
                name,
                labels,
                value,
            }),
    };
}

export function buildHistogram(
    name: string,
    buckets: number[],
    action: (metrics: PrometheusMetric[]) => void
): Histogram {
    return {
        observe: (labels: Record<string, string>, value: number): void => {
            const metrics: PrometheusMetric[] = [];

            // Increment the total count
            metrics.push({
                name: `${name}_count`,
                labels,
                value: 1,
            });

            // Increment the total sum
            metrics.push({
                name: `${name}_sum`,
                labels,
                value,
            });

            // Add all buckets with appropriate values (0 or 1)
            buckets.forEach((bucket) => {
                metrics.push({
                    name: `${name}_bucket`,
                    labels: { ...labels, le: bucket.toString() },
                    value: value <= bucket ? 1 : 0,
                });
            });

            // Increment the +Inf bucket
            metrics.push({
                name: `${name}_bucket`,
                labels: { ...labels, le: '+Inf' },
                value: 1,
            });

            // Send all metrics at once
            action(metrics);
        },
    };
}
